import { USER_ROLE } from '../appConstants';
import Events from '../utilities/EventEmitter';
import { GET_API_USED_AS_POST } from '../api/componentAPIs';

export const checkWritePermissionForUser = (config, apiName) => {
  if (config.method != 'post' || GET_API_USED_AS_POST.hasOwnProperty(apiName)) {
    return config;
  }
  Events.emit('showReadOnlyNotification');
  return Promise.reject({ hasReadOnlyRole: true });
}

export const hasSingleReadOnlyRole = (roles) => {
  return roles.length === 1 && roles.includes(USER_ROLE.READ_ONLY); //check for if user has only one role e.i 'read-only';
}

export const isGetUserInfoAndHasReadOnlyRole = ({ data, config: { url } }) => {
  if (data?.roles && urlIncludes(url, 'GetUserInfo')) {
    return hasSingleReadOnlyRole(data.roles)
  }
  return false;
};

const urlIncludes = (url, searchString) => {
  return url.indexOf(searchString) !== -1;
};
